interface Props {
  text: string;
}

export default function ActionInformationText(props: Props) {
  return (
    <span
      className={`flex justify-center font-bold font-base text-primaryRed h-10 mb-3 items-center`}
    >
      {props.text}
    </span>
  );
}
